import { Injectable, signal, WritableSignal } from '@angular/core';
import { Router } from '@angular/router';
import { User } from '../models/user';
import { AuthApiService } from './apis/auth-api.service';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  profile: WritableSignal<User | null> = signal<User | null>(null);
  constructor(private authApi: AuthApiService, private router: Router) {}

  async getProfile(): Promise<User | null> {
    try {
      const r = await this.authApi.getProfile();
      this.profile.set(r);
      return r;
    } catch (error) {}
    return null;
  }

  async logout(): Promise<void> {
    try {
      const r = await this.authApi.logout();
      this.profile.set(null);
      this.router.navigate(['/']);
    } catch (error) {}
  }
}
